export const containers = { sm: 640, md: 960, lg: 1200, xl: 1440 } as const;
